<script>
import { fandomBasicMixin } from "src/modules/fandom_mixins_module.js";
import { vodafoneLabBasicMixin } from '../../modules/vodafone_lab_mixins_module.js';
import { VodafoneLab } from '../../modules/vodafone_lab_module.js';
import { interactionMixin } from "src/modules/interactions_module.js";
import { get } from "lodash";

export default {
  mixins: [fandomBasicMixin, vodafoneLabBasicMixin, interactionMixin],
  props: {
    customShareSlug: {
      type: String,
      default: ""
    },
    playButton: Boolean
  },
  methods: {
    isUserRegistered: Fandom.isUserRegistered,
    getButtonClass: Fandom.getButtonClass,
    getPrimaryButtonClass: Fandom.getPrimaryButtonClass,
    getSecondaryButtonClass: Fandom.getSecondaryButtonClass,
    linkClass(buttonClass) {
      if (!!buttonClass) {
        return this.isButton(buttonClass) ? `btn ${buttonClass}` : buttonClass;
      }
      return (this.content.theme && this.content.theme == 'dark') ? 'btn btn-white' : 'btn btn-primary';
    },
    updateDownloadInteractionThis() {
      VodafoneLab.checkForInteractionAvailability(get(this.content, ["download"], {}), () => {
        this.updateDownloadInteraction(
          this.containerContent, 
          this.content.download, 
          this.content.download.interaction, 
          () => {}, 
          this.content.download.attachment.url, 
          true, 
          () => {
            if (this.checkRegistration(this.content.download)) {
              console.log(`%cData entry error\n\tdownload repeatable required`, "color: #ff0000");
            } else {
              $("#modal-registration").modal("show");
            }
          }
        );
        return false;
      });
    },
    isButton(buttonClass) {
      return !buttonClass || (buttonClass.indexOf("btn") > -1);
    },
    showContactFormModal() {
      $("#modal-contact-form").modal("show");
    }
  },
  computed: {
    textAlign() {
      // Allowed values: left, right and center.
      return (this.content.text_align) ? `text-${this.content.text_align}` : null;
    },
    hasShareInteraction() {
      return get(this, "content.share.interaction.type", false) === "Share";
    },
    signInRequired() {
      return !Fandom.isUserRegistered() && this.content.enable_sign_in;
    },
    buttonsRequired() {
      return (this.content.button || this.content.buttons || this.playButton || this.content.unregistered_buttons || this.content.download || this.content.evaluation_tool) && !this.signInRequired;
    },
    isArticleHeadingMediaLayout() {
      return get(this, ["mainContent", "layout"], false) === 'page-article-heading-media';
    },
    titleTag() {
      const tagFallback = this.isArticleHeadingMediaLayout ? "h1" : "h2";
      return get(this, ["content", "title_tag"], tagFallback);
    },
    titleClass() {
      const classFallback = this.isArticleHeadingMediaLayout ? "h2" : "h3";
      return get(this, ["content", "title_class"], classFallback);
    },
    subtitleTag() {
      return get(this, ["content", "subtitle_tag"], "h3");
    },
    subtitleClass() {
      const tagClass = get(this, ["content", "subtitle_class"], "h3");
      return Fandom.exists(this.content.subtitle_tag) ? false : tagClass;
    },
    mainClasses() {
      return [
        this.textAlign
      ];
    },
    downloadUrl() {
      return this.checkRegistration(this.content.download) ? get(this.content, ["download","attachment", "url"], "javascript:void(0)") : 'javascript: void(0)';
    }
  }
};
</script>

<template>
  <div :class="mainClasses" text-section-component>
    <img v-if="content.icon" class="icon my-4" :alt="content.icon.alt" :src="content.icon.url">
    <div
      v-if="category"
      class="category d-inline-block px-3 py-1 small mb-4"
      :class="content.category_class ? content.category_class : content.theme == 'dark' ? 'white' : 'primary'"
    >
      <img v-if="categoryIcon && categoryIcon.url" :src="categoryIcon.url" class="category-icon mr-2"/> 
      <i v-else-if="categoryIcon" class="fas mr-2" :class="`fa-${categoryIcon}`"></i>
        {{category}}
    </div>
    <component v-if="content.title" :class="titleClass" :is="titleTag" :style="{'color': content.color}" title>
      {{content.title}}
    </component>
    <component v-if="content.subtitle" :is="subtitleTag" :class="subtitleClass" :style="{'color': `${content.color}`}" subtitle>{{content.subtitle}}</component>
    <component :is="content.description_tag || 'div'" :class="content.description_class" v-if="content.description" :style="{'color': `${content.color}`}" v-html="content.description" description></component>
    <div v-if="buttonsRequired" class="align-btn-group py-4 my-n2">
      <a 
        v-if="content.button" 
        class="m-2 d-inline-block" 
        :target="getTarget(content.button)"
        :class="linkClass(content.button_class)"
        @click.prevent="content.button.url == '$contactForm' ? showContactFormModal() : trackingButtonUrl($event)"
        :href="content.button.url"
      >
        <i v-if="!isButton(content.button_class)" class="far fa-chevron-right mr-2"></i>
        {{content.button.title}}
      </a>
      <a
        class="btn m-2"
        v-if="content.download"
        @click.prevent="updateDownloadInteractionThis()"
        :class="content.download.button_class || 'btn-primary'"
        :href="downloadUrl"
      >{{content.download.title}}</a>
      <button
        v-if="playButton" 
        class="btn shadow-none m-2 my-2" 
        :class="getPrimaryButtonClass(content.play_button_class, content.theme)" 
        @click="$emit('openvideo')"
      >
        {{ft("globals.watch_video")}}
      </button>
      <evaluation-tool-trigger
        class="m-2"
        v-if="content.evaluation_tool" 
        :text="content.evaluation_tool.button_text"
        :content="getContent(content.evaluation_tool.content)"
        :btnClass="getPrimaryButtonClass(content.evaluation_tool.button_class, content.theme)"
      ></evaluation-tool-trigger>
      <template v-if="content.buttons"> 
        <a 
          class="m-2 d-inline-block" 
          v-for="(buttonRecord, index) in content.buttons" 
          :key="index" 
          :class="linkClass(buttonRecord.button_class)"
          :target="getTarget(buttonRecord.button)"
          @click.prevent="buttonRecord.button.url == '$contactForm' ? showContactFormModal() : trackingButtonUrl($event, buttonRecord.button_tracking, buttonRecord.button_event_cookie)"
          :href="buttonRecord.button.url"
        >
          <i v-if="!isButton(buttonRecord.button_class)" class="far fa-chevron-right mr-2"></i>
          {{buttonRecord.button.title}}
        </a>
      </template>
      <template v-if="content.unregistered_buttons && !isUserRegistered()">
        <a 
          class="btn shadow-none m-2" 
          v-for="(buttonRecord, index) in content.unregistered_buttons" 
          :key="index" 
          :class="content.theme == 'dark' ? 'text-white' : 'text-primary'"
          :target="getTarget(buttonRecord.button)"
          @click.prevent="trackingButtonUrl($event, buttonRecord.button_tracking, buttonRecord.button_event_cookie)"
          :href="buttonRecord.button.url"
        >
          <i class="far fa-chevron-right mr-2"></i>
          {{buttonRecord.button.title}}
        </a>
      </template>
    </div>
  </div>
</template>

<style lang="scss">
[text-section-component] {

  .align-btn-group {
    margin-left: -0.5rem;
    margin-right: -0.5rem;
  }

  .icon {
    max-width: 100%;
    width: 6rem;
  }

  h4, .h4 {
    font-family: VodafoneRg;
    font-weight: 800;
  }

  .text-stroke {
    text-stroke: 3px var(--theme-color);
    margin: 0 !important;
    color: transparent;
    font-size: 13rem;
  }

  .h1, h1, .h2, h2, .h3, h3 {
    font-family: VodafoneLt;
  }

  [subtitle] {
    font-family: $font-family-base;
    @include font-size(1.5rem);
    font-weight: normal;
  }
}
</style>
